var nav = require('./nav.json');
var api = require('./api.json');
var centres = require('./centres');
var resources = require('./resources');
var errors = require('./errors');
var analyticEventTypes = require('./analyticEventTypes');
var jwt = require('./jwt');
module.exports = {
  analyticEventTypes: analyticEventTypes,
  api: api,
  centres: centres,
  errors: errors,
  nav: nav,
  resources: resources,
  jwt: jwt
};